<div class="community-questions-modal">
    <div class="community-questions-modal__header">
        <h5 class="community-questions-modal__header--title">
            <i class="fa-solid fa-comments mr-2"></i>
            Community Questions & Answers
        </h5>
        <button class="community-questions-modal__header--close" (click)="closeCommunityQuestionsModal()">
            <i class="fa-solid fa-times"></i>
        </button>
    </div>

    <div class="community-questions-modal__body">
        <!-- Forum Detail Section -->
        <div *ngIf="detailForum?.id; else noForum" class="forum-detail-section">
            <div class="forum-detail-post">
                <div class="forum-detail-post__body">
                    <div class="d-flex gap-2 flex-column px-3 py-3" style="background-color: #eee">
                        <div class="title">{{ detailForum.title }}</div>

                        <div class="grid-image" *ngIf="detailForum?.images?.length > 0">
                            <div style="position: relative; overflow: hidden">
                                <img (error)="commonService.handleError($event)" loading="lazy" class="main-image"
                                    [src]="imgUrl + (detailForum?.activeImage ?? detailForum?.images[0])" />
                            </div>
                            <div class="slide-images">
                                <ng-container *ngFor="let image of detailForum?.images">
                                    <div *ngIf="image != ''" (click)="detailForum.activeImage = image"
                                        [ngStyle]="{ 'background-image': 'url(' + imgUrl + image + ')' }"></div>
                                </ng-container>
                            </div>
                        </div>
                    </div>

                    <div class="content">
                        <div [innerHTML]="detailForum.message"></div>

                        <!-- Comments Section -->
                        <div class="comments">
                            <div class="comments__title">
                                Posts
                                <div class="add" *ngIf="isLogin == 1 && !detailForum.isMuted"
                                    (click)="showMessageBoxReply = !showMessageBoxReply">
                                    Post <i class="fa-solid fa-arrow-alt-circle-down"></i>
                                </div>
                            </div>

                            <!-- Main Reply Box -->
                            <div class="box-reply" *ngIf="isLogin == 1 && showMessageBoxReply">
                                <form (ngSubmit)="storeForumMessageReply()">
                                    <app-editor [(innerValue)]="detailForum.replyText"></app-editor>
                                    <button class="button-2" [class.disabled]="detailForum.hasSubmit"
                                        [disabled]="detailForum.hasSubmit">
                                        <i class="fa-solid fa-paper-plane"></i> Send
                                    </button>
                                </form>
                            </div>

                            <!-- Replies List -->
                            <div class="comments__card" *ngFor="let reply of detailForum?.replies; let i = index">
                                <div class="comments__card--header">
                                    <div class="comments__card--header__left container-char-image">
                                        <img (error)="commonService.handleError($event)" loading="lazy"
                                            src="{{ !reply.user?.image ? '../../../../assets/images/new/badge.png' : imgUrl + reply.user?.image }}" />
                                    </div>
                                    <div class="comments__card--header__name">
                                        {{ reply.user?.userName }}
                                        <span *ngIf="reply.user.level">{{ reply.user.level }}</span>
                                    </div>
                                </div>

                                <div class="comments__card--center">
                                    <div class="comments__card--center__message">
                                        <div *ngIf="!reply.isEdit" class="text {{ isOwnMessage(reply) ? 'own' : '' }}">
                                            <div [innerHtml]="reply.message"></div>
                                            <div class="comments__card--center__list"
                                                *ngIf="isLogin == 1 && !detailForum.isMuted" ngbDropdown>
                                                <div class="comments__card--center__list--bar" ngbDropdownToggle>
                                                    <i class="fa-solid fa-ellipsis-v"></i>
                                                </div>
                                                <div ngbDropdownMenu>
                                                    <button ngbDropdownItem (click)="editForumMessage($event, reply)">
                                                        <i class="fa-solid fa-pen"></i> Edit
                                                    </button>
                                                    <button ngbDropdownItem
                                                        (click)="deleteForumMessageReply($event, reply.id)">
                                                        <i class="fa-solid fa-trash"></i> Delete
                                                    </button>
                                                    <button ngbDropdownItem
                                                        (click)="showReplyMessageBox($event, reply)">
                                                        <i class="fa-solid fa-comment-dots"></i> Reply
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="comments__card--center__details">
                                            <div class="d-flex justify-content-between w-100">
                                                <div class="vote-container">
                                                    <button class="vote-btn upvote-btn"
                                                        [class.active]="reply.userVote === 'upvote'"
                                                        (click)="handleVote(reply, 'upvote')"
                                                        [disabled]="isUserDisabled">
                                                        <i class="fa-solid fa-arrow-up"></i>
                                                        <span class="vote-count" *ngIf="reply.upvotes">{{ reply.upvotes
                                                            || '' }}</span>
                                                    </button>
                                                    <button class="vote-btn downvote-btn"
                                                        [class.active]="reply.userVote === 'downvote'"
                                                        (click)="handleVote(reply, 'downvote')"
                                                        [disabled]="isUserDisabled">
                                                        <i class="fa-solid fa-arrow-down"></i>
                                                        <span class="vote-count" *ngIf="reply.downvotes">{{
                                                            reply.downvotes || '' }}</span>
                                                    </button>
                                                </div>
                                                <div>
                                                    <div *ngIf="!reply.isEdit">
                                                        {{ formatDate(reply.createdAt) }}
                                                    </div>
                                                    <div *ngIf="reply?.replies?.length != 0">{{ reply?.replies.length }}
                                                        posts</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Child Replies -->
                                    <!-- Show/Hide Replies Toggle -->
                                    <div class="replies-toggle" *ngIf="reply?.replies?.length">
                                        <button class="replies-toggle-btn" (click)="toggleReplies(reply)">
                                            <i class="fa-solid fa-chevron-down" [class.rotated]="reply.openReplies"></i>
                                            <span>{{ reply.replies.length }}
                                                {{ reply.replies.length === 1 ? 'reply' : 'replies' }}</span>
                                        </button>
                                    </div>
                                    <div class="comments__card--center__reply"
                                        *ngIf="reply?.replies?.length && reply.openReplies">
                                        <div class="comments__card--center__reply--card"
                                            *ngFor="let child of reply.replies; let iReply = index">
                                            <div class="comments__card--center__reply--card__center">
                                                <div class="name">
                                                    {{ child.user.userName }}
                                                    <span *ngIf="child.user.level">{{ child.user.level
                                                        }}</span>
                                                </div>

                                                <div *ngIf="!child.isEdit"
                                                    class="comments__card--center__reply--card__center--message">
                                                    <div class="text {{ isOwnMessage(child) ? 'own' : '' }}">
                                                        <div [innerHtml]="child.message"></div>
                                                        <div class="comments__card--center__reply--card__center--list"
                                                            *ngIf="!detailForum.isMuted">
                                                            <div class="comments__card--center__reply--card__center--list__bar"
                                                                (click)="handleShowOptionForumReplyChild(child)">
                                                                <i class="fa-solid fa-ellipsis-v"></i>
                                                            </div>
                                                            <div class="comments__card--center__reply--card__center--list__menu"
                                                                (mouseleave)="handleShowOptionForumReplyChild(child)"
                                                                [class.d-none]="!child.showOption">
                                                                <div class="item"
                                                                    (click)="editForumMessageReply($event, child)">
                                                                    <i class="fa-solid fa-pen"></i> Edit
                                                                </div>
                                                                <div class="item"
                                                                    (click)="deleteForumMessageReply($event, child.id, i)">
                                                                    <i class="fa-solid fa-trash"></i> Delete
                                                                </div>
                                                                <div class="item"
                                                                    (click)="showReplyMessageBox($event, child)">
                                                                    <i class="fa-solid fa-comment-dots"></i> Reply
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="d-flex justify-content-between w-100">

                                                        <div class="vote-container">
                                                            <button class="vote-btn upvote-btn"
                                                                [class.active]="child.userVote === 'upvote'"
                                                                (click)="handleVote(child, 'upvote', true)"
                                                                [disabled]="isUserDisabled">
                                                                <i class="fa-solid fa-arrow-up"></i>
                                                                <span class="vote-count" *ngIf="child.upvotes">{{
                                                                    child.upvotes || ''
                                                                    }}</span>
                                                            </button>
                                                            <button class="vote-btn downvote-btn"
                                                                [class.active]="child.userVote === 'downvote'"
                                                                (click)="handleVote(child, 'downvote', true)"
                                                                [disabled]="isUserDisabled">
                                                                <i class="fa-solid fa-arrow-down"></i>
                                                                <span class="vote-count" *ngIf="child.downvotes">{{
                                                                    child.downvotes || ''
                                                                    }}</span>
                                                            </button>
                                                        </div>
                                                        <div class="time">
                                                            {{ formatDate(child.createdAt) }}
                                                        </div>
                                                    </div>
                                                </div>

                                                <!-- Edit Child Reply -->
                                                <ng-container *ngIf="child.isEdit">
                                                    <form (ngSubmit)="storeForumMessageEdit(child)" class="w-100">
                                                        <app-editor [(innerValue)]="child.messageEdit"></app-editor>
                                                        <div class="mt-3 float-right">
                                                            <button type="button" (click)="child.isEdit = false"
                                                                class="btn btn-danger mr-2"
                                                                [class.disabled]="detailForum.hasSubmit"
                                                                [disabled]="detailForum.hasSubmit">
                                                                <i class="fa-solid fa-times"></i> Cancel
                                                            </button>
                                                            <button class="btn btn-primary"
                                                                [class.disabled]="detailForum.hasSubmit"
                                                                [disabled]="detailForum.hasSubmit">
                                                                <i class="fa-solid fa-paper-plane"></i> Send
                                                            </button>
                                                        </div>
                                                    </form>
                                                </ng-container>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Edit Main Reply -->
                                    <ng-container *ngIf="reply.isEdit">
                                        <form (ngSubmit)="storeForumMessageEdit(reply)" class="w-100">
                                            <app-editor [(innerValue)]="reply.messageEdit"></app-editor>
                                            <div class="mt-3 float-right">
                                                <button type="button" (click)="reply.isEdit = false"
                                                    class="btn btn-danger mr-2" [class.disabled]="detailForum.hasSubmit"
                                                    [disabled]="detailForum.hasSubmit">
                                                    <i class="fa-solid fa-times"></i> Cancel
                                                </button>
                                                <button class="btn btn-primary" [class.disabled]="detailForum.hasSubmit"
                                                    [disabled]="detailForum.hasSubmit">
                                                    <i class="fa-solid fa-paper-plane"></i> Send
                                                </button>
                                            </div>
                                        </form>
                                    </ng-container>

                                    <!-- Reply to Main Reply -->
                                    <ng-container *ngIf="reply.showReplyBox">
                                        <form (ngSubmit)="storeForumMessageReply(null, reply)" class="w-100 mt-2">
                                            <app-editor [(innerValue)]="reply.replyText"></app-editor>
                                            <div class="mt-3 float-right">
                                                <button type="button"
                                                    (click)="reply.showReplyBox = false; reply.showOption = false"
                                                    class="btn btn-danger mr-2" [class.disabled]="detailForum.hasSubmit"
                                                    [disabled]="detailForum.hasSubmit">
                                                    <i class="fa-solid fa-times"></i> Cancel
                                                </button>
                                                <button class="btn btn-primary" [class.disabled]="detailForum.hasSubmit"
                                                    [disabled]="detailForum.hasSubmit">
                                                    <i class="fa-solid fa-paper-plane"></i> Send Reply
                                                </button>
                                            </div>
                                        </form>
                                    </ng-container>
                                </div>
                            </div>

                            <div *ngIf="detailForum?.replies?.length < 1">
                                <div class="alert alert-secondary text-center" role="alert">
                                    <i class="fa-regular fa-comment-alt"></i> There are no replies posted at this time
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Community Questions List -->
        <!-- <div class="community-questions-list">
            <ng-container *ngFor="let question of communityQuestionsAndAnswers; let i = index">
                <div *ngIf="question.forum" class="community-question-card" (click)="navigateToForum(question)">
                    <div class="community-question-card__content">
                        <div class="community-question-card__header">
                            <h6 class="community-question-card__title">{{ question.forum.title }}</h6>
                            <span class="community-question-card__date">
                                <i class="fa-solid fa-calendar-alt"></i>
                                {{ question.createdAt | date:'MMM dd' }}
                            </span>
                        </div>
                        <p class="community-question-card__text">{{ question.text }}</p>
                        <div class="community-question-card__footer">
                            <span class="community-question-card__category">{{ question.forum.category }}</span>
                            <i class="fa-solid fa-arrow-right community-question-card__arrow"></i>
                        </div>
                    </div>
                </div>
            </ng-container>

            <div *ngIf="communityQuestionsAndAnswers.length === 0" class="no-questions">
                <div class="no-questions__content">
                    <i class="fa-solid fa-comments no-questions__icon"></i>
                    <h6 class="no-questions__title">No Questions Yet</h6>
                    <p class="no-questions__text">Be the first to ask a question about this category!</p>
                </div>
            </div>
        </div> -->
    </div>

    <ng-template #noForum>
        <div class="no-forum">
            <i class="fa-solid fa-comments"></i>
            <h6 class="no-forum__title">No Forum Found</h6>
            <p class="no-forum__text">Be the first to ask a question about this category!</p>
        </div>
    </ng-template>
</div>